import { include, length } from "app/utils/javascript"

export const addressFormat = (data) => {
    if ((data?.pincodeText || data?.pincode || data?.state || data?.city || data?.address)) {
        return `${(data?.address ? data?.address : "")}, ${(data?.city ? data?.city : "")}, ${(data?.state ? data?.state : "")} ${(data?.pincodeText || data?.pincode || "")}`
    } else {
        return '-'
    }
}

export const addressReportFormat = (data) => {
    if ((data?.pincodeReportText || data?.pincodeReport || data?.stateReport || data?.cityReport || data?.addressReport)) {
        return `${(data?.addressReport ? data?.addressReport : "")}, ${(data?.cityReport ? data?.cityReport : "")}, ${(data?.stateReport ? data?.stateReport : "")} ${(data?.pincodeReportText || data?.pincodeReport || "")}`
    } else {
        return '-'
    }
}

export const toNumber = (value) => value ? Number(value) : value;

export const titleSplit = (string, t) => {
    const temp = string.split('、')
    return temp.map((value) => value.split(/(\d+)/).map((val) => t(val)).join(' ')).join(". ").concat(".")
}

export const numToLocalString = (value) => {
    const num = value ? Number.isInteger(Number(value)) ? value : Number(value.toFixed(2)) : null;
    return num ? num.toLocaleString("en-US") : value;
}

export const setToFixed = (value) => (value || value === 0) ? Number.isInteger(value) ? value : toNumber((+value)?.toFixed(2)) : null;

export const refTypeValidPopMessage = ({ formRefType, cylinderRefType, dispatch, t, jobType }) => {
    let newRefType = []
    if (typeof formRefType === "object") {
        newRefType = length(formRefType) && formRefType.filter((v) => !cylinderRefType.includes(v))
    } else {
        newRefType = [formRefType]
    }
    if (jobType === "recovery") {
        if (length(cylinderRefType) && length(newRefType) && !cylinderRefType.includes(newRefType[0])) {
            const msg = `${t("msg_CylinderContainsRef", { cylinderRefType: cylinderRefType.join(","), newRefType: newRefType.join(",") })}`
            return msg ? msg : null
        }
    } else {
        if (length(cylinderRefType) && length(newRefType) && JSON.stringify(cylinderRefType) !== JSON.stringify(newRefType)) {
            const msg = `${t("msg_CylinderContainsRef", { cylinderRefType: cylinderRefType.join(","), newRefType: newRefType.join(",") })}`
            return msg ? msg : null
        }
    }
}

export const emailListFn = ({ userDetail }) => {
    let emailList = []
    if (userDetail?.emailId && userDetail?.emailId !== "null") { emailList.push({ email: userDetail?.emailId }) }
    if (userDetail?.emailId1 && userDetail?.emailId1 !== "null") { emailList.push({ email: userDetail?.emailId1 }) }
    if (userDetail?.emailId2 && userDetail?.emailId2 !== "null") { emailList.push({ email: userDetail?.emailId2 }) }
    if (userDetail?.emailId3 && userDetail?.emailId3 !== "null") { emailList.push({ email: userDetail?.emailId3 }) }
    if (userDetail?.emailId4 && userDetail?.emailId4 !== "null") { emailList.push({ email: userDetail?.emailId4 }) }
    if (userDetail?.emailId5 && userDetail?.emailId5 !== "null") { emailList.push({ email: userDetail?.emailId5 }) }
    if (userDetail?.emailId6 && userDetail?.emailId6 !== "null") { emailList.push({ email: userDetail?.emailId6 }) }
    if (userDetail?.emailId7 && userDetail?.emailId7 !== "null") { emailList.push({ email: userDetail?.emailId7 }) }
    if (userDetail?.emailId8 && userDetail?.emailId8 !== "null") { emailList.push({ email: userDetail?.emailId8 }) }
    if (userDetail?.emailId9 && userDetail?.emailId9 !== "null") { emailList.push({ email: userDetail?.emailId9 }) }
    if (userDetail?.emailId10 && userDetail?.emailId10 !== "null") { emailList.push({ email: userDetail?.emailId10 }) }
    if (!length(emailList)) {
        emailList.push({ email: undefined })
    }
    return emailList
}

export const setListedData = ({ data, newList }) => {
    let tempData = data;
    if (length(data)) {
        const newIdList = tempData && length(tempData) ? tempData.map(v => v?.id) : []
        const remaining = newList && length(newList) ? newList.filter(v => !include(newIdList, v?.id)) : [];
        tempData = [...data, ...remaining];
    } else {
        tempData = [...newList]
    }
    return tempData
}

export const getDuplicatesInArray = (array) => [...new Set(array)]

export const languageFn = (language) => {
    switch (language) {
        case "id":
            return "bh"
    
        default:
            return language;
    }
}

export const cylinderListSorting = (cylinderList = []) => {
    const getCapacityValue = (capacity = "") => {
        const match = capacity.match(/(\d+(?:\.\d+)?)\s*kg/i);
        return match ? parseFloat(match[1]) : 0;
    };

    const processPriority = {
        DISPOSE: 1,
        RECYCLE: 2,
    };

    const compare = (a, b) => {
        const processA = a.processRequestType || '';
        const processB = b.processRequestType || '';
        const priorityA = processPriority[processA] || 99;
        const priorityB = processPriority[processB] || 99;

        if (priorityA !== priorityB) return priorityA - priorityB;

        const capacityA = getCapacityValue(a.capacity);
        const capacityB = getCapacityValue(b.capacity);
        if (capacityA !== capacityB) return capacityB - capacityA;

        const refrigerantA = a.allRefrigerantType?.[0]?.toUpperCase() || '';
        const refrigerantB = b.allRefrigerantType?.[0]?.toUpperCase() || '';
        if (refrigerantA !== refrigerantB) return refrigerantA.localeCompare(refrigerantB);

        const toolA = a.toolName?.toUpperCase() || '';
        const toolB = b.toolName?.toUpperCase() || '';
        return toolA.localeCompare(toolB);
    };

    const quickSort = (arr) => {
        if (arr.length <= 1) return arr;

        const pivot = arr[arr.length - 1];
        const left = [];
        const right = [];

        for (let i = 0; i < arr.length - 1; i++) {
            if (compare(arr[i], pivot) < 0) {
                left.push(arr[i]);
            } else {
                right.push(arr[i]);
            }
        }

        return [...quickSort(left), pivot, ...quickSort(right)];
    };

    return quickSort([...cylinderList]);
};

export const isImage = (value) => /\.(jpg|jpeg|png|webp|gif|bmp|svg)$/i.test(value);

export const isInvalidValue = (value) => {
    return (
      value === null ||
      value === undefined ||
      (typeof value === "string" && value.trim() === "") ||
      (typeof value === "number" && value < 0)
    );
}
